export const specFieldsOrder = [
    'macAddress',
    'macAddressZigbee',
    'stationName',
    'name',
    'nameLeft',
    'nameRight',
    'type',
    'subtype',
    'room',
    'roomLeft',
    'roomRight',
    'hwVersion',
    'manufacturer',
    'image',
    'customer',
    'command',
    'customer2',
    'command2',
    'battery',
    'firmware',
    'firmwareName',
    'reconstructionStatus',
    'protocolId',
    'protocolHistory',
    'brandId',
    'operatingMode',
    'wifiChip',
    'shield',
    'setupDate',
    'lastSetup',
    'lastReset',
    'lastUpdate',
    'rfStatus',
    'rfRating',
    'lastStatusStored',
    'lastSeen',
    'lastData',
    'lastActivity',
    'eventualDoubleMac',
    'boilerControl',
    'dhwControl',
    'packaging',
    'bubendorffMotorType',
    'routerId',
    'thermalControl',
    'homekitStatus',
    'status',
    'uptime',
    'fwPrivate',
    'controlledDevices',
    'controlledDevicesLeft',
    'controlledDevicesRight',
    'reachable',
    'configured',
    'mfgId',
    'applianceType',
    'mode',
    'energyType',
    'button',
    'packagingId',
    'line',
    'subline',
    'lineName',
    'ergonomicId',
    'sdStatus',
    'alimStatus',
    'monitoring',
    'installationVoltage',
    'installationIlim',
    'stateOfCharge',
    'stateOfHealth',
    'nbCharge',
    'batteryTemperatureLevel',
    'tampered',
    'tamperDetection',
    'alimentation',
    'autoTrigger',
    'notifyRule',
    'recordRule',
    'sirenSoundRule',
    'sirenEntryDelay',
    'radioId',
    'calibrationMinMax',
    'lastCalibration',
    'motorSpeed',
    'voltageDrop',
    'batteryDead',
    'shareWeatherMap',
    'ticStatus',
    'ticType',
    'refurbished',
    'migrated',
    'weatherMapIsFiltered',
    'weatherMapFilteringReason',
    'wifiChannel',
    'feedbackGiven',
];

export const operationsOrder = {
    harmless: [
        'dump',
        'dumpLogs',
        'statsDump',
        'statsDumpVerbose',
        'modelDump',
        'getOEMInfos',
        'logs',
        'ping',
        'timeline',
        'installQRCode',
        'resetQRCode',
        'triggerLogsDump',
        'getLocalResources',
        'diagnosis'
    ],
    moderate: [
        'setDump',
        'recalibrateCO2',
        'recomputeHeating',
        'resetMigrationFlag',
        'mainloop',
        'orderReboot',
        'deleteCache',
        'enableSsh',
        'unlock',
        'associateUser',
    ],
    dangerous: [
        'electricalReset',
        'homekitReset',
        'reset',
        'fullReset',
        'switchDatabase',
        'resetMigrationSecret',
        'resetFlag',
        'moveToTemporaryHome',
        'dissociate',
        'importData',
        'rollbackMigration',
    ],
};

export const modulesOrder = {
    NAMain: [
        'NAModule1',
        'NAModule3',
        'NAModule2',
        'NAModule4',
    ],
} as { [key: string]: string[] };
